import JobsActions from './jobs.actions';

const initialState = {

};

export const mapJobStatus = (job) => {
  job.job_status = '--';
  switch ((job.status || '').toLowerCase().trim()) {
    case 'pending ae review':
    case 'blessed by ae':
    case 'pending review':
    case 'blessed':
    case 'pending vetting':
      job.job_status = 'Shortlisted';
      break;
    case 'included in packet':
    case 'pending onboarding':
    case 'sourced talent':
    case 'needs technical interview':
    case 'trial failed due to dev\'s fault':
    case 'obsolete':
    case 'engagement finished':
    case 'job lost or no customer response':
    case 'job paused':
    case 'candidate not interested':
    case 'candidate not reachable for interview':
    case 'selected for another job':
      job.job_status = 'In Review';
      break;
    case 'scheduling client interview':
    case 'interview scheduled':
    case 'awaiting interview':
    case 'feedback':
    case 'selected for interview':
    case 'awaiting interview feedback':
    case 'awaiting client decision':
      job.job_status = 'Interviewing';
      break;
    case 'selected for trial':
    case 'in trial':
    case 'trial passed':
      job.job_status = 'Hired';
      break;
    case 'rejected by ae':
    case 'soft interview rejection':
    case 'hard interview rejection':
    case 'not selected from packet':
    case 'rejected':
    case 'rejected by vel':
    case 'rejected by vetting':
      job.job_status = 'Not selected';
      break;
  }
  return job;
};

function JobsReducer(state = initialState, action) {
  const { type = '', payload = {} } = { ...action };
  switch (type) {
    case JobsActions.SET_JOBS: {
      const jobs = payload.userJobs.map(job => mapJobStatus(job));
      return { ...state, ...{ userJobs: jobs } };
    }
    
    case JobsActions.SET_RECOMMENDED_JOBS: {
        return {
          ...state, ...{
            recommended_jobs: payload,
        }
      };
    }

    case JobsActions.START_FETCHING_RECOMMENDED_JOBS: {
      return {
        ...state,
        loading: true,
        recommendedJobsLoading: true
      };
    }

    case JobsActions.END_FETCHING_RECOMMENDED_JOBS: {
      return {
        ...state,
        loading: false,
        recommendedJobsLoading: false
      };
    }

    case JobsActions.FINISH_APPLYING_RECOMMENDED_JOBS: {
      return {
        ...state,
        loading: false,
        recommendedJobsLoading: false,
        recommended_jobs: {
          ...state.recommended_jobs,
          applyUrl: payload
        }
      };
    }

    case JobsActions.SET_FASTRACK_FLOWS: {
      return {
        ...state, ...{
          fastrack: payload,
          fastrackLoading: false,
        }
      };
    }

    case JobsActions.START_FETCHING_FASTRACK_FLOWS: {
      return {
        ...state,
        loading: true,
        fastrackLoading: true,
      };
    }

    case JobsActions.END_FETCHING_FASTRACK_FLOWS: {
      return {
        ...state,
        loading: false,
        fastrackLoading: false
      };
    }

    case JobsActions.SET_JOBS_APPLIED: {
      return {
        ...state, ...{
          jobs_applied: payload,
      }
    };
    }

  case JobsActions.START_FETCHING_JOBS_APPLIED: {
    return {
      ...state,
      loading: true,
      jobsAppliedLoading: true
    };
  }

  case JobsActions.END_FETCHING_JOBS_APPLIED: {
    return {
      ...state,
      loading: false,
      jobsAppliedLoading: false
    };
  }

  case JobsActions.START_FETCHING_V2_JOBS: {
    return {
      ...state,
      jobsV2Loading: true
    }
  }

  case JobsActions.END_FETCHING_V2_JOBS: {
    return {
      ...state,
      jobsV2Loading: false
    }
  }

  case JobsActions.SET_V2_JOBS: {
    return {
      ...state,
      ... {jobsV2: payload}
    }
  }

  case JobsActions.SET_PENDING_JRF: {
    return {
      ...state,
    }
  }


    default:
      return { ...state };
  }
}

export default JobsReducer;
